export enum Fonction {
    Mecanicien = "Technicien/Mécanicien",
    Marin = "Batelier",
    Administratif = "Administratif",

}
